import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { useTheme } from '../../ThemeContext';

import PhotoCrop from '../PhotoCrop';

import {
  Photobox,
  PhotoHolder,
  Photo,
  PhotoPlaceholder,
  Input,
  Button,
} from './ProfilePhotoChanger.style';

const ProfilePhotoChanger = ({ input, currentPhoto }) => {
  const intl = useIntl();
  const theme = useTheme();
  const [sourcePhoto, setSourcePhoto] = useState(undefined);

  const [visibleModalPhotoCrop, setVisibleModalPhotoCrop] = useState(undefined);

  const selectFile = (sourcePhoto) => {
    if (sourcePhoto) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setSourcePhoto(reader.result);
        openModal();
      });
      reader.readAsDataURL(sourcePhoto);
    }
  };

  const setPhoto = (newPhoto) => {
    input.onChange(newPhoto.blob);
    closeModal();
  };

  const openModal = () => {
    setVisibleModalPhotoCrop(true);
  };

  const closeModal = () => {
    setVisibleModalPhotoCrop(false);
  };

  return (
    <>
      <Photobox>
        <PhotoHolder theme={theme.profilePhotoChanger.photoHolder}>
          {(input && input.value) || currentPhoto ? (
            <Photo
              theme={theme.profilePhotoChanger.photo}
              src={
                (input.value && URL.createObjectURL(input.value)) ||
                currentPhoto
              }
              alt={''}
            />
          ) : (
            <PhotoPlaceholder theme={theme.profilePhotoChanger.photo} />
          )}
        </PhotoHolder>

        <Input
          type='file'
          accept='image/x-png,image/jpeg'
          onClick={(event) => {
            event.target.value = null;
          }}
          onChange={(event) => {
            if (event.target.files && event.target.files.length > 0) {
              selectFile(event.target.files[0]);
            }
          }}
        />
        <Button theme={theme.button.normal} widthAuto noMask tiny>
          {intl.formatMessage({ id: 'PROFILE_PHOTO_CHANGER.UPLOAD' })}
        </Button>
      </Photobox>
      {visibleModalPhotoCrop && (
        <PhotoCrop
          handleClose={() => closeModal()}
          sourcePhoto={sourcePhoto}
          handlePhoto={(newPhoto) => setPhoto(newPhoto)}
        />
      )}
    </>
  );
};

ProfilePhotoChanger.propsTypes = {
  input: PropTypes.object,
  photoURL: PropTypes.string,
};

export default ProfilePhotoChanger;
